import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin, of } from 'rxjs';
import { LoginVM } from '../models/account/login-vm';
import { LoginVM3 } from '../models/account/login-vm';
import { InvestorModel } from '../models/investor/investor-vm';
import { OrderBookFilterVM } from '../models/orderbook/order-book-filter-vm';
import { ApiService } from './core/api.service';
import { map } from 'rxjs/operators';
import { MfReportModel } from '../models/report/MfReportModel';
import _ from 'lodash';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  public async getLoginResponses(a: LoginVM.loginCred) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/login2');
    const data = (d: LoginVM.loginCred) => {
      return this.apiService.returndata(d.l, d.p);
    }
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data(a), httpOptions);
      return response;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  public async getLoginResponse(_data: LoginVM3) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/login');
    const data = {
      LoginName: _data.LoginName,
      Password: _data.Password,
      LoginUserType: _data.LoginUserType
    }
    const httpOptions = await this.apiService.getHttpOptionsByKey();

    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  public mfPortfolio = null;
  public async getMfPortfolio(_data: InvestorModel.MfPortfolioReportVM2, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      ArnNumber: _data.ArnNumber,
      AsOnDate: _data.AsOnDate,
      InvestorItemType: _data.InvestorItemType,
      InvestorItemId: _data.InvestorItemId,
      RefKey: "string",
      ContextMenuCode: "string",
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.MfPortfolioDataOM(response.Data);
        this.mfPortfolio = of(result)
      }
      return result;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  public async getOrderStatusReport(orderBookfilter: OrderBookFilterVM) {
    const urlForNormal = this.apiService.getFcApiUrl('/fcapi/reports/mf/order-book/normal');
    // const urlForSystematic = this.apiService.getFcApiUrl('/fcapi/reports/mf/order-book/systematic');

    const httpOptions = await this.apiService.getHttpOptionsByToken();
    const dataForAcceptancePendingApi = {
      FromDate: orderBookfilter.FromDate,
      ToDate: orderBookfilter.ToDate,
      InvestorId: orderBookfilter.InvestorId,
      OrderStatus: 'ALL_APPROVAL_PENDING_ORDERS', //ALL_APPROVAL_PENDING_ORDERS / Approval Pending
      ContextMenuCode: orderBookfilter.ContextMenuCode
    }
    // const dataForNormalApi = {
    //   FromDate: orderBookfilter.FromDate,
    //   ToDate: orderBookfilter.ToDate,
    //   InvestorId: orderBookfilter.InvestorId,
    //   OrderStatus: null,
    //   ContextMenuCode: orderBookfilter.ContextMenuCode
    // }

    // const dataForSystematicApi = {
    //   FromDate: orderBookfilter.FromDate,
    //   ToDate: orderBookfilter.ToDate,
    //   InvestorId: orderBookfilter.InvestorId,
    // }
    try {
      let responseForAcceptancePendingNormal = await this.apiService.post(urlForNormal, dataForAcceptancePendingApi, httpOptions);
      // let responseForNormal = await this.apiService.post(urlForNormal, dataForNormalApi, httpOptions);
      // let responseForSystematic = await this.apiService.post(urlForSystematic, dataForSystematicApi, httpOptions);

      return await Promise.all([responseForAcceptancePendingNormal]).then(results => Promise.all(results.map(r => r.Data)));
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  public categoryList = null;
  public async getRecommendationCategory(_data, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.CategoryListOM(response.Data);
        this.categoryList = of(result.Data)
      }
      return result.Data;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  public recommendationlist = null;
  public async getRecommendationList(recommendationList: InvestorModel.RecommendationListVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-recommendation/list');
    const data = {
      RecCategoryId: recommendationList.recommendationId,
      loader: recommendationList['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.RecommendationListOM(response.Data);
      }
      return result.Data;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  public mfSipReport = null;
  public async getMfSipReport(sipReport: InvestorModel.SipBookReportInputVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      ReportType: sipReport.ReportType,
      InvestorId: sipReport.InvestorId,
      FromDate: sipReport.FromDate,
      ToDate: sipReport.ToDate,
      RefKey: "string",
      loader: sipReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SipReportListOM(response.Data);
        this.mfSipReport = of(result.Data);
      }
      return result.Data;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }
  public mfStpReport = null;
  public async getMfStpReport(stpReport: InvestorModel.RegisteredSTPReportVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      ReportType: stpReport.ReportType,
      InvestorId: stpReport.InvestorId,
      FromDate: stpReport.FromDate,
      ToDate: stpReport.ToDate,
      RefKey: "string",
      loader: stpReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.StpReportListOM(response.Data);
        this.mfStpReport = of(result.Data)
      }
      return result.Data;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }
  public mfSwpReport = null;
  public async getMfSwpReport(swpReport: InvestorModel.RegisteredSWPReportVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      InvestorId: swpReport.InvestorId,
      FromDate: swpReport.FromDate,
      ToDate: swpReport.ToDate,
      ReportType: swpReport.ReportType,
      RefKey: "string",
      ContextMenuCode: "string",
      loader: swpReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SwpReportListOM(response.Data);
        this.mfSwpReport = of(result.Data);
      }
      return result.Data;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  // public async getInvestorListByPAN(pan: string) {
  //   //http://localhost:3000/api/gws/account/investor/login-by-pan/investor-list
  //   const url = this.apiService.getFcApiUrl('/api/gws/account/investor/login-by-pan/investor-list');
  //   const data = {'pan': pan};
  //   const httpOptions = await this.apiService.getHttpOptionsByToken();
  //   try {
  //     const response = await this.apiService.post(url, data, httpOptions);
  //     let list: LoginVM.InvestorByPAN[] = [];
  //     response.forEach(i => {
  //       list.push(LoginVM.InvestorByPAN.resolve(i));
  //     });
  //     return response;
  //   } catch (error) {
  //     //  this.apiService.handleError(error);
  //     throw new Error(JSON.stringify(error));
  //   }
  // }

  // public async getOtpByInvestorAndPan(pan: string,id:string) {
  //   const url = this.apiService.getFcApiUrl('/api/gws/account/investor/login-by-pan/send-otp');
  //   const data = {'pan': pan, 'investorId': id};
  //   const httpOptions = await this.apiService.getHttpOptionsByToken();
  //   try {
  //     const response:any = await this.apiService.post(url, data, httpOptions);
  //     let result:any;
  //     if(response){
  //       result = LoginVM.OtpVM.resolve(response);
  //     }
  //     return result;
  //   } catch (error) {
  //     // this.apiService.handleError(error);
  //     throw new Error(JSON.stringify(error));
  //   }
  // }

  // public async verifyOtp(val:any){
  //   const url = this.apiService.getFcApiUrl('/api/gws/account/investor/login-by-pan/verify-otp');
  //   const data = {
  //     'execution': val.execution,
  //     'tab_id': val.tab_id,
  //     'session_code': val.session_code,
  //     'challenge': val.challenge,
  //     'auth_session_id': val.auth_session_id,
  //     'otp_value': val.otp_value,
  //     'pkce_code_verifier': val.pkce_code_verifier
  //   };
  //   const httpOptions = await this.apiService.getHttpOptionsByToken();
  //   try {
  //     const response:any = await this.apiService.post(url, data, httpOptions);
  //     let result:any;
  //     if(response){
  //       result = LoginVM.OtpVerify.resolve(response);
  //     }
  //     return result;
  //   } catch (error) {
  //     // this.apiService.handleError(error);
  //     throw new Error(JSON.stringify(error));
  //   }
  // }


  // public async getFolioListByPan(pan:string){
  //   const url = this.apiService.getFcApiUrl('/api/gws/account/investor/login-by-pan/get-folio-mobile-email');
  //   const data = {
  //     'PAN': pan,

  //   };
  //   const httpOptions = await this.apiService.getHttpOptionsByToken();
  //   try {
  //     const response:any = await this.apiService.post(url, data, httpOptions);
  //     let list: LoginVM.FolioByPAN[] = [];
  //     response.forEach(i => {
  //       list.push(LoginVM.FolioByPAN.resolve(i));
  //     });
  //     return response;
  //   } catch (error) {
  //     // this.apiService.handleError(error);
  //     throw new Error(JSON.stringify(error));
  //   }
  // }

  // public async getInvestorDetailViaKra(pan: string,date:string) {
  //   const url = this.apiService.getFcApiUrl('/api/gws/account/investor/get-pan-kra-details');
  //   const data = {PAN:pan, Dob: date}
  //   const httpOptions = await this.apiService.getHttpOptionsByToken();

  //   try {
  //     const response:any = await this.apiService.post(url, data, httpOptions);
  //     let result:any;
  //     if(response){
  //       if(response.kycStatus==false){
  //         result = LoginVM.PanKraDetails.resolve(response);
  //       }
  //     }
  //     return result;
  //   } catch (error) {
  //     // this.apiService.handleError(error);
  //     throw new Error(JSON.stringify(error));
  //   }
  // }
  public orderBookData = null;
  public async getOrderBookData(orderBookfilter: OrderBookFilterVM, isRefresh: boolean = false) {
    const baseEndpoint = '/fcapi/reports/mf/order-book';
    
    // Only the 'normal' endpoint supports /refresh
    const urlForNormal = this.apiService.getFcApiUrl(`${baseEndpoint}/normal${isRefresh ? '/refresh' : ''}`);
    
    // SIP, STP, and SWP do not have /refresh endpoints
    const urlForSip = this.apiService.getFcApiUrl(`${baseEndpoint}/sip`);
    const urlForStp = this.apiService.getFcApiUrl(`${baseEndpoint}/stp`);
    const urlForSwp = this.apiService.getFcApiUrl(`${baseEndpoint}/swp`);

    const httpOptions = await this.apiService.getHttpOptionsByToken();

    const dataForNormalApi = {
      FromDate: orderBookfilter.FromDate,
      ToDate: orderBookfilter.ToDate,
      InvestorId: orderBookfilter.InvestorId,
      OrderStatus: null,
      ContextMenuCode: orderBookfilter.ContextMenuCode,
      loader: orderBookfilter['loader']
    }
    try {
      let responseForNormal = this.apiService.post(urlForNormal, dataForNormalApi, httpOptions);
      let responseForSip = this.apiService.post(urlForSip, dataForNormalApi, httpOptions);
      let responseForStp = this.apiService.post(urlForStp, dataForNormalApi, httpOptions);
      let responseForSwp = this.apiService.post(urlForSwp, dataForNormalApi, httpOptions);

      this.orderBookData = of(await Promise.all([responseForNormal, responseForSip, responseForStp, responseForSwp]).then(results => Promise.all(results.map(r => r.Data))));
      return await Promise.all([responseForNormal, responseForSip, responseForStp, responseForSwp]).then(results => Promise.all(results.map(r => r.Data)));
    } catch (error) {
      throw error;
    }
  }
  
  public mfAllocationReport = null;
  public async getMFAllocationReport(alloc_Report: InvestorModel.MFAllocationVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      ArnNumber: alloc_Report.ArnNumber,
      AsOnDate: alloc_Report.AsOnDate,
      InvestorItemId: alloc_Report.InvestorItemId,
      InvestorItemType: alloc_Report.InvestorItemType,
      RefKey: "string",
      loader: alloc_Report['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.MFAllocationOM(response.Data);
        this.mfAllocationReport = of(result.Data);
      }
      return result.Data;
    } catch (error) {      
      throw error;
    }
  }

  public mfPerformanceReport = null;
  public async getMfPerformanceReport(swpReport: MfReportModel.OverallMfGainLossVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      ArnNo: swpReport.ArnNo,
      InvestorItemType: swpReport.InvestorItemType,
      InvestorItemId: swpReport.InvestorItemId,
      FromDate: swpReport.FromDate,
      ToDate: swpReport.ToDate,
      RefKey: "string",
      ContextMenuCode: "string",
      loader: swpReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.MfPerformanceDataOM(response.Data);
        this.mfPerformanceReport = of(result);
      }
      return result;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }
  public mfTransactionReport = null;
  public async getMfTransactionReport(swpReport: MfReportModel.MultiAssetTransactionReportVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      FromDate: swpReport.FromDate,
      ToDate: swpReport.ToDate,
      RequestType: swpReport.RequestType,
      RequestId: swpReport.RequestId,
      Arn: swpReport.Arn,
      loader: swpReport['loader']
    }

    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = _.sortBy(new InvestorModel.TransactionReportListOM(response.Data).Data, [function (o) { return format(new Date(o.TranDate), "yyyy-MM-dd'T'HH:mm:ssxxx"); }]).reverse();
        this.mfTransactionReport = of(result);
      }
      return result;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }
  public mfGainLossReport = null;
  public async getMfGainLossReport(swpReport: MfReportModel.InvestorDateRangeVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data =
    {
      FromDate: swpReport.FromDate,
      ToDate: swpReport.ToDate,
      InvestorId: swpReport.InvestorId,
      RefKey: "string",
      loader: swpReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.GainLossReportListOM(response.Data);
        this.mfGainLossReport = of(result);
      }
      return result;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  async getSchemeData(schCode: number): Promise<Observable<any>> {
    const url = this.apiService.getFcApiUrl('/api/mf/scheme/info');
    const data = {
      SchemeCode: schCode
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response: any = await this.apiService.postPipe(url, data, httpOptions).pipe(map(results => results.Schemes[0]));
      if (response) {
        result = response;
      }
      return result;
    } catch (error) {
      this.apiService.handleError(error);
    }
  }


  async getSchemeInfo(schCode: number) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/info');
    const data = {
      SchemeCode: schCode,
      loader: schCode['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response) {
        result = response;
      }
      return result;
    } catch (error) {
      this.apiService.handleError(error);
    }
  }

  async getAdminDashboardReport(_data, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      loader: _data['loader'],
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response) {
        result = response;
      }
      return result;
    } catch (error) {
      this.apiService.handleError(error);
    }
  }

  async getAdminDashboardSIPReport(_data, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      loader: _data['loader'],
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response) {
        result = response;
      }
      return result;
    } catch (error) {
      this.apiService.handleError(error);
    }
  }

  async getSubBrokerDashboardReport() {
    const url = this.apiService.getFcApiUrl('/fcapi/sub-broker/dashboard');
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.get(url, httpOptions);
      if (response) {
        return response;
      }
      return null;

    } catch (error) {
      this.apiService.handleError(error);
      return null;
    }
  }

  async getCollectionReport(CollectionReport: InvestorModel.DashCollectionReportVM, endpoint: string) {
    const url = this.apiService.getFcApiUrl(endpoint);
    const data = {
      FromDate: CollectionReport.FromDate,
      ToDate: CollectionReport.ToDate,
      loader: CollectionReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.DashCollectionReportOM(response.Data);
        this.mfGainLossReport = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }
}
